<template>
  <div >
    <div class="container">
      <div class="w1200">
        <div class="disf disfac disfjc">
          <div><img width="48px" height="42px" src="@/assets/images/logo2.png" alt=""></div>
          <div class="ml10">
            <div>
              <img width="360px" height="40px" src="@/assets/images/logoText4.png" alt="">
            </div>
          </div>
        </div>
        <div class="disf disfjb bord p1 mt30 gap20">
          <selects class="flex1" @callback="callback" title="政府网站" :option="option"></selects>
          <selects class="flex1" @callback="callback" title="行业协会"  :option="option2"></selects>
          <selects class="flex1" @callback="callback" title="大件许可申报网站"  :option="option3"></selects>
          <!-- <div class="titles fs20 disf disfac">友情链接：
            <selects @callback="callback" title="全国跨省大件并联许可平台" :option="option" ></selects>
          </div>
          <div class="titles fs20 disf disfac">省级大件申报平台：
            <selects  @callback="callback" title="市政府部门网站"  :option="option2"></selects>
          </div> -->
        </div>
        <div  class="disf disfjb mt20">
          <div class="">
            <div>
              <div class="mt5">
                <span class="titles fs18">客服热线(全国)：</span>
              </div>
              <div class="mt5 fs24">
                <span>13717652020</span>
              </div>
            </div>
          </div>
          <div class="disf">
            <div class="tc">
              <img src="@/assets/images/12cm.jpg" width="76px" height="77px">
              <p class="titles fs14">关注公众号</p>
            </div>
            <div class="tc ml20">
              <img src="@/assets/images/applod.png" width="76px" height="77px">
              <p class="titles fs14">APP下载链接</p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="links">
      <div class="w1200 disf disfjb">
        <div>
          安可行（北京）数据智能科技有限公司 ｜ 2025版权所有
        </div>
        <div class="pointer" @click="callback('https://beian.miit.gov.cn/')">
          京ICP备2024088503号-3
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import selects from '../selects/index.vue'
import {mapState} from 'vuex'
export default {
  name: 'index',
  data() {
    return {
      t: '1',
      selects: false,
      option: [],
      option2:  [],
      option3:  [],
    }
  },
  computed: {
    ...mapState([
      'contact'
    ]),
  },
  methods: {
    callback (item) {
      window.open(item)
    }
  },
  props: {
    linkData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    linkData (d) {
      if (d.friendshipLinks) {
        this.option = d.governmentDepts.map(m=>{return {value: m.url, label: m.name}})
        this.option2 = d.friendshipLinks.map(m=>{return {value: m.url, label: m.name}})
        this.option3 = d.provincialPlatforms.map(m=>{return {value: m.url, label: m.name}})
      }
    }
  },
  components: {
    selects
  }
}
</script>


<style scoped lang="less">
.container{
  width: 100%;
  background: url("../../assets/images/footerBg.png") no-repeat;
  background-size: cover;
  height: 326px;
  padding-top: 33px;
  padding-bottom: 33px;
}
.links{
  width: 100%;
  background: #3C9BA4;
  height: 62px;
  line-height: 62px;
  font-size: 16px;
  color: #FFFFFF;
}
.w1200{
  width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
}
.titles{
  color: #7993A8;
}
.bord{
  border-bottom: 1px dashed #FFFFFF;
  padding-bottom: 20px;
}

.mt30 {
  margin-top: 30px;
}

.pointer {
  cursor: pointer;
}

.gap20 {
  gap: 20px;
}

.flex1 {
  flex: 1;
}
</style>